import React from "react";
import Icon from "./Icon";

export const ArrowBackIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.582 13H7.41203L12.292 17.88C12.682 18.27 12.682 18.91 12.292 19.3C11.902 19.69 11.272 19.69 10.882 19.3L4.29203 12.71C3.90203 12.32 3.90203 11.69 4.29203 11.3L10.872 4.69997C11.262 4.30997 11.892 4.30997 12.282 4.69997C12.672 5.08997 12.672 5.71997 12.282 6.10997L7.41203 11H18.582C19.132 11 19.582 11.45 19.582 12C19.582 12.55 19.132 13 18.582 13Z" fill="#23410A"/>
  </Icon>
);
